import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-data',
  templateUrl: './data.component.html',
  styleUrls: ['./data.component.scss']
})
export class DataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
